import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import "./style.css";
import pdficon from './../Asset/PDF.png'
import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment';
import fav_icon from './../Asset/New_Assert/ESO_ICON.png';
import { red } from "@mui/material/colors";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { Helmet } from 'react-helmet';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { Breadcrumbs, Typography } from "@mui/material";
import GetAppIcon from '@mui/icons-material/GetApp';
import Loader from "../CommonLoader";
import { Commonfun } from './../Commonfun';
import { timezonechange } from './../Commonfun';
import { timezoneval } from './../Commonfun';
import { AppContext } from "../../../Context/Context";
import { Utils } from "../../../Utils/Utils";
import searchEngine from "../Asset/ESO/search-engine.svg";
import WarningCountimage from "../Asset/esocardicon/SchemaDetail/WarningCount.svg"
import ErrorCountimage from "../Asset/esocardicon/SchemaDetail/ErrorCount.svg"
import Commoncard from "../Commoncard";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import UserActivityTracker from "../../../hooks/userActivityTracker";



export default function Schemadetail({ reportStatus = false, instantReport = "" }) {
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);

  const [cardData, setCardData] = useState([]);
  const [jobidData, setjobidData] = useState("");
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(new Date());
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [value, onChange] = React.useState();
  const [valueOutside, onChangeOutsidde] = React.useState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [domainsecdata, setDomainsecdata] = useState("")
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [isDownloading, setIsDownloading] = useState(false);
    const [schemaAnalysisPlan, setschemaAnalysisPlan] = useState({ status: true, error: "" });
    const [aiModalOpen, setAiModalOpen] = useState(false);
    const [selectedAiFix, setSelectedAiFix] = useState("");
    const [activeSchemaType, setActiveSchemaType] = useState("");
    const [markedTypes, setMarkedTypes] = useState([]); 
  const navigate = useNavigate();
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value

  var hasNumber = /\d/;


  const [jobDate, setjobDate] = useState("");

  let querystring = useParams();
  let plag_id = querystring.id;
  let jobdataid = querystring.jobid;


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const apihandleClose = () => {
    setapiOpen(false);
  };
  const [validation, setValidation] = useState({
    dateerror: ""
  });
  let errors = { ...validation };
  let subtitle;


  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

  /* */
  useEffect(() => {

    setTimeout(() => {

      const keyElements = document.querySelectorAll('.schemaOutputeso .key_val_row .key');

      keyElements.forEach(element => {
        if (element.textContent.trim() !== '') {
          element.classList.add('newClass');
        }
      });

    }, 2000);

  }, []);
  /* */

  const arr = [];
 const handleOpenAiFix = async (errorLine, schemaType) => { 
    if (!errorLine) return;
    setLoading(true);
    try {
      const payload = {
        report_id: parseInt(plag_id), 
        error_line: decodeURIComponent(errorLine),
        type: schemaType,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}schema/schema_detaildata/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobdataid}&id=${plag_id}`, 
        payload, 
        { headers: { Authorization: `${ApiToken}` } }
      );

      if (response.data.status === "success" && response.data.fix) {
        const fixData = response.data.fix;
        
       
        let snippetText = "";
        if (typeof fixData === 'string') {
            snippetText = fixData;
        } else if (fixData.full_corrected_snippet) {
            snippetText = fixData.full_corrected_snippet;
        } else if (fixData.suggestion) {
            snippetText = fixData.suggestion;
        } else {
           
            snippetText = JSON.stringify(fixData, null, 2);
        }

        setSelectedAiFix(snippetText);
        setActiveSchemaType(schemaType);
        setAiModalOpen(true);
      } else {
        toast.warning("AI could not generate a fix for this property.");
      }
    } catch (error) {
      toast.error("Failed to generate AI suggestion.");
    } finally {
      setLoading(false);
    }
};

  useEffect(() => {
    window.handleOpenAiFix = handleOpenAiFix;
    return () => { delete window.handleOpenAiFix; };
  }, []);

  const checkUserPlan = async () => {
    const schemaAnalysisP = await Utils("schema_analysis", ApiToken);
    if (schemaAnalysisP.status) {
      if (!reportStatus) {
        callUserdataApi();
      }
    }
    setschemaAnalysisPlan(schemaAnalysisP);
  };

  useEffect(() => {
    if (reportStatus) {
      applyInstantReport();
    }
    checkUserPlan();
  }, [instantReport]);
  const columns = [

    {
      field: 'links',
      headerName: 'Page URL',
      width: 600,
      sortable: false,
      disableClickEventBubbling: true,
    },
    {
      field: 'results',
      headerName: 'Status',
      width: 300,
      renderCell: (cardData) => { if (cardData.row.result == "failed") { return (<p className="read_score_org_faile" style={{ color: red }}>{`Fail`}</p>); } else { return (<p className="read_score_gry_success">{`Pass`}</p>); } }
    },
    {
      field: '',
      headerName: 'View',
      width: 300,
      renderCell: (cardData) => { return (<button className="view-report-button">View Report</button>); }
    },

  ];

  const rows = cardData


  const [SchemaUrl, SetSchemaUrl] = useState('')
  const [ErrorCount, SetErrorCount] = useState(0)
  const [WarningCount, SetWarningCount] = useState(0)





const callUserdataApi = async () => {
    setLoading(true);
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}schema/schema_detaildata/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobdataid}&id=${plag_id}`, {
        headers: { Authorization: `${ApiToken}` },
      });

      if (datavalue?.data) {
        const dataval = datavalue?.data;
        setCardData(dataval);
        SetSchemaUrl(dataval?.table_data[0]?.link__url);
        SetErrorCount(dataval?.table_data[0]?.error_count);
        SetWarningCount(dataval?.table_data[0]?.warning_count);

        
        const currentlyMarked = dataval.table_data[0].update_status || [];
        setMarkedTypes(currentlyMarked);

        var schemaOutputElement = document.getElementById('schemaOutput');
        if (schemaOutputElement) {
          schemaOutputElement.innerHTML = generateSchemaHTML(dataval?.table_data[0]?.schema_error_json, currentlyMarked);
        }
      }
    } catch (e) { console.log(e); }
    setLoading(false);
  };
  const applyInstantReport = () => {

    if (instantReport) {
      SetSchemaUrl('')
      SetErrorCount(0)
      SetWarningCount(0)
      setjobDate(moment(new Date()).format("MMMM DD,YYYY HH:mm"))
      if (instantReport) {
        const dataval = instantReport;
        setCardData(dataval);
        SetSchemaUrl(dataval?.table_data[0]?.url)
        SetErrorCount(dataval?.table_data[0]?.error_count)
        SetWarningCount(dataval?.table_data[0]?.warning_count)
        var schemaOutputElement = document.getElementById('schemaOutput');
        schemaOutputElement.innerHTML = generateSchemaHTML(dataval?.table_data[0]?.schema_error_json);
      }
    };
  }

  const reportNow = async () => {
    setLoading(true);
    var errs = 1
    let errors = {};
    if (startDate == "" || endDate == "") {
      errors.dateerror = "This field is required.";
      errs = 2
    }
    else {
      errors.dateerror = "";
      errs = 1
      setValidation(errors);
    }
    if (errs == 2) {
      return setValidation(errors);
    }
    var start_date = moment(startDate).format('YYYY-MM-DD')
    var end_date = moment(endDate).format('YYYY-MM-DD')

    const datavalue = await axios.get(
      `${process.env.REACT_APP_API_URL}content/analysis_summary_crawl_dates/?start_date=${start_date}&end_date=${end_date}`, {
      headers: {
        Authorization: `${ApiToken}`,
      },
    }
    ).catch((error) => {
      if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error)
      }
      else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
        navigate('/errorpages')
      }
    });
    if (datavalue?.data?.result?.length > 0) {
      const dataval = datavalue?.data?.result[0]?.job_id;
      setjobidData(dataval);
      callUserdataApi()

    }
    else {
      handleClickOpen()
    }

  }


  function openModal() {
    setIsOpen(true);
  }



  function closeModal() {
    setIsOpen(false);
  }


  function generateSchemaHTML(schemaData, currentMarked = markedTypes) {




    var output = "<ul>";
    for (var key in schemaData) {
      if (typeof schemaData[key] === 'object') {
       output += "<li class='parent'>" + '' + " " + generateSchemaHTMLChild(schemaData[key], currentMarked) + "</li>";
      } else {


        if (key === 'required') {

          output += "<li style='color:#ffae1f'><div data-key=" + key + " class='key_val_row'><div class='key'></div> <div class='val'>" + schemaData[key] + "</div></div></li>";
        }
        else if (key === 'recommended') {

          output += "<li style='color:#3547d3'><div data-key=" + key + " class='key_val_row'><div class='key'></div> <div class='val'>" + schemaData[key] + "</div></div></li>";
        }
        else {

          if (key.startsWith("warning_")) {
            output += "<li style='color:#3547d3'><div data-key=" + key + " class='key_val_row'><div class='key'></div> <div class='val'>" + schemaData[key] + "</div></div></li>";
          } else {

            if (hasNumber.test(key)) {
              output += "<li><div data-key=" + key + " class='key_val_row'><div class='key'></div> <div class='val'>" + schemaData[key] + "</div></div></li>";
            }
            else {
              output += "<li><div data-key=" + key + " class='key_val_row'><div class='key'>" + key + "</div> <div class='val'>" + schemaData[key] + "</div></div></li>";
            }

          }
        }

      }
    }
    output += "</ul>";
    return output;
  }

function generateSchemaHTMLChild(schemaData, currentMarked = markedTypes) {
  var output = "<ul class='child' style='padding: 0px'>";
  const schemaType = schemaData["@type"] || "Unknown";

  for (var key in schemaData) {
    if (key === 'ai_fix') continue;

    if (typeof schemaData[key] === 'object' && schemaData[key] !== null) {
      if (key === 'required' || key === 'recommended') {
        let arrayOutput = "";
        
        let itemColor = key === 'required' ? '#ffae1f' : '#3547d3';

        for (let i = 0; i < schemaData[key].length; i++) {
          let errorText = schemaData[key][i];
          let aiButton = "";

          if (key === 'required') {
            const escapedErrorText = encodeURIComponent(errorText);
           
            const btnStyle = "padding: 6px 12px; background-color: #ff601f; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 12px; font-weight: 500; margin-bottom: 8px; margin-top: 5px; font-family: sans-serif; display: block;";
            aiButton = `<button type="button" style="${btnStyle}" onclick="handleOpenAiFix('${escapedErrorText}', '${schemaType}')">AI Suggestion</button>`;
          }

          
          arrayOutput += `<li><div class='key_val_row'><div class='val' style='color: ${itemColor}'>${aiButton}${errorText}</div></div></li>`;
        }
        output += `<li data-key='${key}'>${arrayOutput}</li>`;
      } 
      else {
        output += `<li data-key='${key}'>${hasNumber.test(key) ? '' : `<span class='tle_key'>${key}</span>`}${generateSchemaHTMLChild(schemaData[key], currentMarked)}</li>`;
      }
    } 
    else {
      output += `<li><div class='key_val_row'><div class='key'>${hasNumber.test(key) ? '' : key}</div><div class='val'>${schemaData[key]}</div></div></li>`;
    }
  }
  return output + "</ul>";
}
const handleMarkForDeployment = async () => {

    if (loading) return;
    
    setLoading(true);
    try {
        const payload = {
            job_id: parseInt(jobdataid),
            link_id: parseInt(plag_id),          
            detail_id: cardData?.table_data[0]?.id,
            url: SchemaUrl,
            requested_changes: activeSchemaType, 
            suggestion: selectedAiFix,          
            is_updated: true,
            user_domain_id: parseInt(esodata.domaindata.value.header_selected),
        };

        const response = await axios.post(`${process.env.REACT_APP_API_URL}autodeploy/update/`, payload, {
            headers: { Authorization: `${ApiToken}` }
        });

        if (response.data.message.includes("Successfully") || response.data.message.includes("Already")) {
            const newMarkedList = [...markedTypes, activeSchemaType];
            setMarkedTypes(newMarkedList);
            
           
            toast.dismiss();
            toast.success(response.data.message, { toastId: "deploy-success" });
            
            setAiModalOpen(false);

            const schemaOutputElement = document.getElementById('schemaOutput');
            if (schemaOutputElement) {
                schemaOutputElement.innerHTML = generateSchemaHTML(cardData?.table_data[0]?.schema_error_json, newMarkedList);
            }
        }
    } catch (error) {
     
        toast.dismiss();

       
        const errorMessage = error?.response?.data?.error || error?.response?.data?.message || "Failed to mark for deployment";

     
        if (error?.response?.status === 400) {
            setapierrorMsg(errorMessage);
            setapiOpen(true); 
        } else {
           
            toast.error(errorMessage, { toastId: "deploy-error-toast" });
        }
    } finally {
        setLoading(false);
    }
};
const handleGlobalDeploy = async () => {
    
    if (loading) return;
    
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}autodeploy/deploy/?job_id=${jobdataid}&user_domain_id=${esodata.domaindata.value.header_selected}`, 
        { headers: { Authorization: `${ApiToken}` } }
      );

     
      if (response.data.message) {
        toast.success(response.data.message);
      } else if (response.data.urls) {
        toast.success(`Deployment started for ${response.data.urls.length} URLs`);
      }
      
    }  catch (error) {
      if (error?.response?.status === 400 && error?.response?.data?.error) {
        setapierrorMsg(error.response.data.error);
        setapiOpen(true);
      } else {
        toast.error(error?.response?.data?.message || "Error starting deployment");
      }
    }
    setLoading(false);
  };
  const pdfdown = async () => {

    setLoading(true);
    setIsDownloading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}schema/schema_detaildata/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobidData}&id=${plag_id}&domain_section_id=${domainsecdata}&job_id=${jobdataid}&formats=pdf&timezone=${timezoneval()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("SchemaDetail", "pdf", ApiToken, esodata.domaindata.value.header_selected);

        link.download = filedata;
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        toast.error("No Data", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });

        console.error('Failed to fetch PDF:', response.status, response.statusText);
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloading(true);

  }

  // const cardDatas = [
  //   { title: "Error Count", value: ErrorCount, iconSrc: ErrorCountimage, altText: "ErrorCount" },
  //   { title: "Warning Count", value: WarningCount, iconSrc: WarningCountimage, altText: "High Impact Issues" }
  // ];


  const cardDatas = [
    {
      value: ErrorCount,
      title: "Error Count",
      altText: "ErrorCount",
      iconSrc: ErrorCountimage,
      iconColor: 1,
      bgColor: 1
    },
    {
      value: WarningCount,
      title: "Warning Count",
      altText: "Medium Impact Issue Occurrences",
      iconSrc: WarningCountimage,
      iconColor: 2,
      bgColor: 2
    },



  ];

  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleDownlodingPDF = () => {
    pdfdown();
  }

  return (

    <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      {loading === true ? <Loader /> : null}

      <Helmet>
        <meta charSet="utf-8" />
        <title>Schema Detail</title>
      </Helmet>

      {!reportStatus &&
        <Container maxWidth={false} className="dashboard-container">
          <Box className="dashboard-box">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={4}>
                <div>
                  <h1 className="dashboard_header">
                    Schema Analysis Detailed Report
                  </h1>
                </div>
              </Grid>
              <Grid item xs={12} md={8}>
                <div className="top_breadcrumb_menu">
                  <div className="exportpdf_outer">
                    <div className="breadcrumb-wrapper">
                      <CommonBreadCrumb breadcrumbValue={[
                        { title: 'Technical' },
                        { title: 'Schema Analysis', activeColor: true, link: '/schema-analysis' },
                        { title: 'Schema Analysis Detailed Report', activeColor: true }
                      ]} />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>
      }

<Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6}>
              <div className="time_zone">
                <span>
                  <a target="_blank" href={SchemaUrl} rel="noreferrer">
                    <span style={{ display: 'inline-block' }} className="spanlink">
                      {SchemaUrl}
                    </span>
                  </a>
                </span>
                <br />
                <span className="timezone-date">{timezonechange(jobDate)} </span>
                <br />
                <span className="timezone-val">{timezoneval()}</span>
              </div>
            </Grid>
            {!reportStatus && (
              <Grid item xs={12} md={6}>
                <div className="download-pdf-ceneter">
                  {schemaAnalysisPlan.status && (
                    <div style={{ display: "flex", justifyContent: "end", gap: "10px" }}>
                      {/* Download PDF Button */}
                      <div
                        className="dashboard_download"
                        style={{ cursor: isDownloading ? "not-allowed" : "pointer", display: "flex", alignItems: "center" }}
                        onClick={isDownloading ? null : pdfdown}
                      >
                        Download PDF
                        <svg
                          style={{ marginLeft: "8px" }}
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          viewBox="0 0 24 24"
                        >
                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                          <polyline points="7 10 12 15 17 10" />
                          <line x1="12" y1="15" x2="12" y2="3" />
                        </svg>
                      </div>

                      {/* Deploy Now Button */}
                      <div
                        className="dashboard_download"
                        style={{
                          cursor: loading ? "not-allowed" : "pointer",
                          display: "flex",
                          alignItems: "center",
                          opacity: loading ? 0.7 : 1,
                        }}
                        onClick={loading ? null : handleGlobalDeploy}
                      >
                        Deploy Now
                        <svg
                          style={{ marginLeft: "8px" }}
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <line x1="22" y1="2" x2="11" y2="13"></line>
                          <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                        </svg>
                      </div>
                    </div>
                  )}
                </div>
              </Grid>
            )}
          </Grid>
        </Box>
      </Container>

      {/* <Container maxWidth={false} className="dashboard-card-container">
        <Box className="dashboard-box-card">
          <Grid container className="dashboard-card-grid">

            <Grid item xs={12} md={12}>

              <div className="common-card-container" style={{ justifyContent: "center" }}>
                {cardDatas.map(({ title, value, iconSrc, altText }) => (
                  <Commoncard key={title} title={title} value={value} iconSrc={iconSrc} altText={altText} nonclikable={true} />
                ))}
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container> */}


      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="">
                <div className="cnt_hdr_content_table">
                  <div className="box_wrap schemaOutputeso" id="schemaOutput">

                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {!reportStatus &&
        <Container maxWidth={false} className="footer-container">
          <Box className="footer-box">
            <Grid container className="footer-grid">
              <Grid item xs={12} md={6}>
                <div className="footer-left">
                  <p className="footer-text">
                    All Rights Reserved Copyright © 2026 |
                    <a href="https://www.egrovesys.com/" target="blank">
                      <span className="footer-brand"> Elite site Optimizer</span>
                    </a>
                  </p>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className="footer-right">
                  <p>{/* Add content if needed */}</p>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>
      }

      {/* <div className="cnt_audit_outer_wrap">
        <div className="top_breadcrumb_menu">
          <CommonBreadCrumb breadcrumbValue={[
            { title: 'Technical' },
            { title: 'Schema Analysis', activeColor: true, link: '/schema-analysis' },
            { title: 'Schema Analysis Detailed Report', activeColor: true }
          ]} />
          <div className="exportpdf_outer">
            {schemaAnalysisPlan.status &&
              <>
                <button className="exportpdf" alt="pdf icon" onClick={isDownloading ? null : pdfdown} title="PDF Download" ><GetAppIcon />PDF</button>
              </>
            }
          </div>
        </div>
        <div className="cnt_hdr_top_wraps">
          <div className="cnt_hdr_top_lft_wrap">
            <h2 className="heading_font">Schema Analysis Detailed Report</h2>
            <a target="_blank" href={SchemaUrl} style={{ display: 'flex', flexDirection: 'column' }}>
              <span className="spanlink" style={{ flexDirection: "column" }}>
                {SchemaUrl}
              </span>
            </a>
            <p style={{ fontSize: "14px", letterSpacing: "0.8px", color: "#ff601fc2" }}>as of {timezonechange(jobDate)}  <span style={{ fontWeight: 700 }}>  {timezoneval()} </span></p>


          </div>
        </div>


        <div className="cnt_hdr_content">
          <div className="box_wrap">
            <div>
              <h1></h1>
              <p> </p>
            </div>

            <div className="common-card-container" style={{ justifyContent: "center" }}>
              {cardDatas.map(({ title, value, iconSrc, altText }) => (
                <Commoncard key={title} title={title} value={value} iconSrc={iconSrc} altText={altText} nonclikable={true} />
              ))}
            </div>

          </div>
        </div>

        <div className="cnt_hdr_content_table">
          <div className="box_wrap schemaOutputeso" id="schemaOutput">

          </div>
        </div>






      </div> */}
{}
      <Dialog
        open={aiModalOpen}
        onClose={() => setAiModalOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ bgcolor: '#f5f5f5', color: '#333', fontWeight: 'bold', py: 1.5 }}>
          {"AI Suggestion"}
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="alert-dialog-slide-description">
            <Box sx={{ mb: 2 }}>
            
              <Box 
                sx={{ 
                  maxHeight: "350px", 
                  overflowY: "auto", 
                  bgcolor: '#f8f9fa', 
                  p: 2, 
                  borderRadius: '4px',
                  border: '1px solid #ddd',
                  fontFamily: 'monospace',
                  fontSize: '13px',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-all',
                  color: '#2c3e50'
                }}
              >
                {selectedAiFix}
              </Box>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
 <Button 
    onClick={handleMarkForDeployment}
    variant="contained"
    disabled={markedTypes.includes(activeSchemaType)}
    sx={{ 
        bgcolor: '#ff601f', 
        '&:hover': { bgcolor: '#e5561a' }, 
        textTransform: 'none',
        '&.Mui-disabled': { bgcolor: '#ff601f', color: 'white', opacity: 0.7 } 
    }}
>
    {markedTypes.includes(activeSchemaType) ? "✅ Marked for deployment" : "Mark for deployment"}
</Button>
          <Button 
            onClick={() => setAiModalOpen(false)} 
            variant="outlined"
            sx={{ color: '#333', borderColor: '#ccc', textTransform: 'none', '&:hover': { borderColor: '#999', bgcolor: '#f5f5f5' } }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <CommonErrorAlert
        data={{
          apiopen: apiopen,
          apiErrorMsg: apierrorMsg,
          isIconStyled: true
        }}
        closeAlert={apihandleClose} />

      <UserActivityTracker pagename="Technical - Schema Analysis - Schema Analysis Detailed Report" />
    </div>


  );
}